import request from '@/utilsCloud/request'
import port from './port'

// 获取所有岗位数据
export function enterprisePostList(data) {
  return request({
    url: port.biz + '/employee/enterprisePostList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    params: data
  })
}


// 获取私有课程分类
export function getPrivateCourseCates(query) {
  return request({
    url: port.course + '/home/getPrivateCourseCates',
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取线下课程的列表
export function getUnderlineCourseListFromEnterprise(query) {
  return request({
    url: port.course + '/enterprise/underline/getUnderlineCourseListFromEnterprise',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取专业列表
export function getPostByEntpId(query) {
  return request({
    url: port.biz + '/registration/getPostByEntpId',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取轮播图
export function getGatewayHomeBannerList(query) {
  return request({
    url: port.biz + '/banner/getGatewayHomeBannerList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取站内新闻
export function getMyNews(query) {
  return request({
    url: port.biz + '/news/getMyNews',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取行业资讯
export function getIndustryNew(query) {
  return request({
    url: port.biz + '/news/getIndustryNews',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取学习时长排行榜
export function getStudyTimeRankingList(query) {
  return request({
    url: port.course + '/employee/getStudyTimeRankingList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取学习时长排行榜
export function getEnterpriseWebsite(query) {
  return request({
    url: port.course + '/enterprise/getEnterpriseWebsite',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取学习时长排行榜
export function getMustAndStartingCourse(query) {
  return request({
    url: port.course + '/home/getMustAndStartingCourse',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}




// 获取站内新闻
export function getNewsInformationList(query) {
  return request({
    url: port.biz + '/news/getNewsInformationList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取站点装修配置
export function getWebsite() {
  return request({
    url: port.biz + '/enterprise/homeWebsite',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: {}
  })
}





// WEBPACK FOOTER //
// ./src/apiCloud/home.js